export default __webpack_public_path__ + "static/slider2-1-7360d5f8deb1ea1da381a1743ba77611.png";